import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import SelectSearch from 'react-select-search';
import { SlideDown } from 'react-slidedown';
import { ARROW_DOWN } from '../../constants/iconNames';
import Icon from '../../icons';
import { iconBlue } from '../../styles/variables.scss';
export default function QuantityDropdown({ amount, dropDownValues, selected, showDropdown, toggleDropdown, value, }) {
    return (_jsx("div", { className: "quantity__dropdown", children: _jsxs(OutsideClickHandler, { onOutsideClick: showDropdown ? () => toggleDropdown() : () => () => { }, children: [_jsxs("button", { onClick: toggleDropdown, children: [amount, _jsx("span", { className: showDropdown ? 'rotate-up' : 'rotate-down', children: _jsx(Icon, { stroke: iconBlue, name: ARROW_DOWN }) })] }), _jsx(SlideDown, { className: "slidedown", transitionOnAppear: false, closed: !showDropdown, children: _jsx(SelectSearch, { autofocus: true, onChange: selected, options: dropDownValues, value: value, search: false }) })] }) }));
}
QuantityDropdown.propTypes = {
    toggleDropdown: PropTypes.func.isRequired,
    selected: PropTypes.func.isRequired,
    dropDownValues: PropTypes.arrayOf(PropTypes.any).isRequired,
    showDropdown: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
};
